<template>
  <div ref="rootRef" class="l3">
    <a class="skip" href="#contenido">Saltar al contenido</a>
    <main id="contenido">
      <section class="hero wrap" aria-labelledby="titulo">
        <div class="hero-copy">
          <div class="eyebrow">Catálogo / La base de tu negocio</div>
          <h1 v-if="isCopyV2" id="titulo">
            Tus servicios y precios,<br />
            <span class="accent">listos para el próximo<br />presupuesto.</span>
          </h1>
          <h1 v-else id="titulo">
            Los 2 minutos<br />tienen un secreto.<br />
            <span class="accent">Tu lista<br />de precios.</span>
          </h1>
          <p v-if="isCopyV2">
            Empezá con la lista que ya usás. Prio te ayuda a organizarla para preparar
            presupuestos sin volver a cargar cada servicio y precio.
          </p>
          <p v-else>
            Hay una parte que hacés vos: armar la base. Una vez, en diez minutos, con lo que ya
            tengas. Después, cada presupuesto arranca de acá.
          </p>
          <a class="cta" :href="SIGNUP_URL"
            >Probá gratis 30 días <span aria-hidden="true">↗</span>
          </a>
          <div class="guarantee">Sin tarjeta</div>
        </div>
        <div class="scene-wrap">
          <div id="scene" class="scene" :data-state="sceneState">
            <div class="orbit" aria-hidden="true"></div>
            <span class="spark" aria-hidden="true">✳</span>
            <div id="mess" class="sheet mess" :aria-hidden="sceneState !== 'mess'">
              <div class="mono">NOTAS / ÚLTIMA EDICIÓN 2024</div>
              <div class="mess-text">
                catering x persona <span>12mil</span> <br />deco tematica <span>280</span>
                <br />mesa dulce 120.000<br />dj ???
              </div>
              <p class="mono" style="margin-top: 16px">¿Cuál era el precio nuevo?</p>
            </div>
            <div id="clean" class="sheet clean" :aria-hidden="sceneState !== 'clean'">
              <div class="mono">CASA OLIVIA / TU MARCA</div>
              <div class="sheet-title">Mis servicios <span class="accent">✦</span></div>
              <div class="row">
                <span
                  >Catering premium<small style="display: block; color: var(--muted)"
                    >Por persona</small
                  >
                </span>
                <b>$ 12.000</b>
              </div>
              <div class="row">
                <span>Decoración</span>
                <b>$ 280.000</b>
              </div>
              <div class="row">
                <span>Mesa dulce</span>
                <b>$ 120.000</b>
              </div>
              <p class="demo-note">DJ: precio pendiente de revisar.</p>
            </div>
            <div id="seal" class="seal" :aria-hidden="sceneState !== 'clean'">
              ✓ Tu lista, organizada.
            </div>
          </div>
          <div class="scene-controls" role="group" aria-label="Comparar la nota y la lista">
            <button
              type="button"
              data-action="catalog-scene"
              data-context="mess"
              :aria-pressed="sceneState === 'mess'"
              data-scene="mess"
              @click="setScene('mess')"
            >
              Como la tenés
            </button>
            <span aria-hidden="true">→</span>
            <button
              type="button"
              data-action="catalog-scene"
              data-context="clean"
              :aria-pressed="sceneState === 'clean'"
              data-scene="clean"
              @click="setScene('clean')"
            >
              Como queda
            </button>
          </div>
          <p class="scene-caption">Ejemplo ilustrativo. Vos revisás antes de confirmar.</p>
        </div>
      </section>
      <div class="ribbon">
        <template v-if="isCopyV2"
          >Una base que aprovechás <span aria-hidden="true">✳</span> en cada presupuesto.</template
        >
        <template v-else>
          Diez minutos de base. <span aria-hidden="true">✳</span> No diez minutos por cliente.
        </template>
      </div>
      <section class="section wrap" aria-labelledby="contexto">
        <div class="section-heading reveal">
          <div>
            <div class="eyebrow">{{ isCopyV2 ? 'Tu lista, lista para usar' : 'No es otra lista para mantener' }}</div>
            <h2 v-if="isCopyV2" id="contexto">
              Tu catálogo es la base<br />
              <span class="accent">para analizar consultas<br />y preparar presupuestos.</span>
            </h2>
            <h2 v-else id="contexto">
              Todo lo que hace Prio<br />
              <span class="accent">lee de esta lista.</span>
            </h2>
          </div>
          <p>
            Si tus precios viven en una nota vieja, cada consulta empieza con una búsqueda. Ponelos
            en un lugar que el resto del negocio pueda usar.
          </p>
        </div>
        <div class="stats reveal" :data-copy="isCopyV2 ? 'v2' : 'v1'">
          <template v-if="isCopyV2">
            <article class="stat">
              <strong aria-hidden="true">≡</strong>
              <div>
                <h3>Una lista viva.</h3>
                <p>La usás en cada presupuesto, sin recargar precios.</p>
              </div>
            </article>
            <article class="stat">
              <strong aria-hidden="true">✦</strong>
              <div>
                <h3>Base para analizar.</h3>
                <p>Consultas cruzadas con tus servicios y precios.</p>
              </div>
            </article>
            <article class="stat">
              <strong aria-hidden="true">✓</strong>
              <div>
                <h3>Tus precios, tu revisión.</h3>
                <p>Prio propone. Vos confirmás antes de compartir.</p>
              </div>
            </article>
          </template>
          <template v-else>
            <article class="stat">
              <strong>
                <span data-count="2">2</span>
                <small>min</small>
              </strong>
              <div>
                <h3>Por presupuesto.</h3>
                <p>La IA no te pregunta los precios cada vez. Los busca acá.</p>
              </div>
            </article>
            <article class="stat">
              <strong> <span data-count="24">24</span>/7</strong>
              <div>
                <h3>Consultas analizadas.</h3>
                <p>Lo que pide tu cliente se cruza con tus servicios y tus precios.</p>
              </div>
            </article>
            <article class="stat">
              <strong>0</strong>
              <div>
                <h3>Precios inventados.</h3>
                <p>Prio usa lo que cargaste. Si no está, no se lo imagina.</p>
              </div>
            </article>
          </template>
        </div>
        <p class="context-end reveal">
          <template v-if="isCopyV2"
            ><b>Una lista que usás en cada presupuesto.</b> Sin búsquedas entre notas
            viejas.</template
          >
          <template v-else
            ><b>Plomería, no magia.</b> No se luce tanto. Hace que todo lo demás
            funcione.</template
          >
        </p>
      </section>
      <section class="section steps-section" id="como" aria-labelledby="pasos">
        <div class="wrap">
          <div class="steps-head reveal">
            <div class="eyebrow">Una vez / Tres pasos</div>
            <h2 id="pasos">
              No arranques de cero.<br />
              <span class="accent">Arrancá de ese lío.</span>
            </h2>
            <p>
              La lista ya la tenés. Aunque esté repartida entre un Excel, una foto y tu memoria.
            </p>
          </div>
          <article class="step">
            <div class="step-copy reveal">
              <span class="step-number">01 / TRAÉ LO QUE HAY</span>
              <h3>Pegá lo que tengas.<br />Así como esté.</h3>
              <p>
                Excel, notas, PDF, una foto. Hasta podés dictarlo por voz. Sin plantilla, sin
                acomodar columnas, sin pasar todo en limpio primero.
              </p>
              <div class="aside-note">
                El trabajo es juntar tus precios.<br />No aprender un formato nuevo.
              </div>
            </div>
            <div class="mock reveal">
              <div class="mock-top">
                <span class="mono">IMPORTAR SERVICIOS</span>
                <span class="tag">Ejemplo</span>
              </div>
              <div class="sources" aria-label="Fuentes admitidas">
                <span>Excel</span>
                <span>Notas</span>
                <span>PDF</span>
                <span>Foto</span>
                <span>Voz</span>
              </div>
              <label class="paste-label" for="paste">Tu lista, sin pasar en limpio</label>
              <textarea class="paste" id="paste" readonly spellcheck="false">
catering premium x persona 12mil
deco tematica 280
mesa dulce 120.000
vajilla 95.000</textarea
              >
              <button
                id="import"
                class="small-button"
                type="button"
                data-action="review-import"
                @click="importExample"
              >
                Importar con IA <span aria-hidden="true">✦</span>
              </button>
              <p class="demo-note">Demo con texto de ejemplo. No sube archivos ni usa IA real.</p>
            </div>
          </article>
          <article class="step" id="revision">
            <div class="step-copy reveal">
              <span class="step-number">02 / ORDEN, CON TU VISTO BUENO</span>
              <h3>La IA acomoda.<br />Vos das el sí.</h3>
              <p v-if="isCopyV2">
                Propone nombres prolijos, descripciones profesionales y categorías. Cuando algo es
                ambiguo, como ese “280” de tu nota, lo revisás y lo confirmás vos antes de
                seguir.
              </p>
              <p v-else>
                Entiende “12mil” y ese “280” de tu nota. Propone nombres prolijos, descripciones
                profesionales y categorías. Vos revisás los importes y confirmás cada servicio.
              </p>
              <div v-if="isCopyV2" class="aside-note">
                En este ejemplo, Prio propone $ 280.000 para ese “280”.<br />Vos confirmás si es
                correcto.
              </div>
              <div v-else class="aside-note">
                En este ejemplo, “280” pasa a $ 280.000.<br />Tu revisión vale más que cualquier
                suposición.
              </div>
            </div>
            <div class="mock reveal" id="review">
              <div class="mock-top">
                <span class="mono">REVISAR IMPORTACIÓN</span>
                <span class="tag">Tu última palabra</span>
              </div>
              <div class="review-summary">✦ 4 servicios · 2 categorías</div>
              <div id="review-cards">
                <div v-for="service in services" :key="service.name" class="review-card">
                  <div>
                    <b>{{ service.name }}</b>
                    <span class="price">{{
                      formatMoney(service.price ?? 0) +
                      ' · ' +
                      service.unit.toLocaleLowerCase('es-AR')
                    }}</span>
                    <p>{{ service.description }}</p>
                    <span class="tag">{{ service.category }}</span>
                  </div>
                  <button
                    type="button"
                    class="confirm"
                    data-action="review-confirm"
                    :data-context="service.name"
                    :aria-pressed="confirmed.includes(service.name)"
                    :aria-label="'Confirmar ' + service.name"
                    @click="toggleConfirm(service.name)"
                  >
                    ✓
                  </button>
                </div>
              </div>
              <p id="review-status" class="demo-note" role="status">{{ reviewStatus }}</p>
            </div>
          </article>
          <article class="step">
            <div class="step-copy reveal">
              <span class="step-number">03 / YA ES PARTE DEL TRABAJO</span>
              <h3>Buscás. Tocás +.<br />Al presupuesto.</h3>
              <p>
                Tu lista queda viva, agrupada por categoría. Buscá “mesa dul” y agregá el servicio
                en un toque. Sin copiar el nombre ni volver a tipear el precio.
              </p>
              <div class="aside-note">
                ¿Cobrás distinto según el trabajo?<br />Dejá consultoría como <b>Variable</b> y poné
                el monto en cada presupuesto.
              </div>
            </div>
            <div class="mock reveal">
              <div class="mock-top">
                <span class="mono">MIS SERVICIOS</span>
                <span class="tag">Demo interactiva</span>
              </div>
              <label class="search-label" for="search">Buscá un servicio</label>
              <input
                id="search"
                v-model="search"
                class="search"
                type="search"
                data-input="catalog-search"
                placeholder="Probá “mesa dul”"
                autocomplete="off"
              />
              <div id="live-list">
                <template v-for="category in categories" :key="category">
                  <template v-if="matchesFor(category).length">
                    <div class="category-title">{{ category }}</div>
                    <div v-for="item in matchesFor(category)" :key="item.name" class="live-row">
                      <div>
                        <b
                          ><template v-if="highlight(item.name)"
                            >{{ highlight(item.name)?.pre
                            }}<mark>{{ highlight(item.name)?.match }}</mark
                            >{{ highlight(item.name)?.post }}</template
                          ><template v-else>{{ item.name }}</template></b
                        >
                        <small :class="{ variable: item.price === null }">{{
                          priceLabel(item)
                        }}</small>
                        <form
                          v-if="variableOpen === item.name"
                          class="variable-entry"
                          @submit.prevent="submitVariable(item)"
                        >
                          <input
                            v-model="variableAmount"
                            type="number"
                            min="1"
                            step="1"
                            required
                            placeholder="Monto en $"
                            data-input="variable-amount"
                            :aria-label="'Monto de consultoría para este presupuesto'"
                          />
                          <button type="submit">Agregar</button>
                        </form>
                      </div>
                      <button
                        class="add"
                        type="button"
                        data-action="list-add"
                        :data-context="item.name"
                        :disabled="added.includes(item.name)"
                        :aria-label="'Agregar ' + item.name + ' al presupuesto de ejemplo'"
                        @click="addService(item, item.price)"
                      >
                        {{ added.includes(item.name) ? '✓' : '+' }}
                      </button>
                    </div>
                  </template>
                </template>
                <p v-if="!visibleCount" class="demo-note">
                  No hay servicios con ese nombre. Probá otra búsqueda.
                </p>
              </div>
              <div id="quote-status" class="quote-status" role="status">{{ quoteStatus }}</div>
            </div>
          </article>
        </div>
      </section>
      <section class="section wrap" id="ajuste" aria-labelledby="ajuste-title">
        <div class="proof-heading reveal">
          <div class="eyebrow">Hecho para Argentina</div>
          <h2 id="ajuste-title">
            Subió todo un 10%.<br />
            <span class="accent">No vayas uno por uno.</span>
          </h2>
          <p>
            Mové el porcentaje. Ajustá toda la lista o solo una categoría, con redondeo inteligente
            a $ 500. {{ isCopyV2 ? 'Un clic y seguís.' : 'Un click y seguís.' }}
          </p>
        </div>
        <div
          id="proof"
          class="proof reveal"
          data-context="price-adjustment"
          :data-negative="percent < 0"
        >
          <div class="adjust-controls" data-context="price-controls">
            <div class="mono">EL PAÍS CAMBIA. TU LISTA ACOMPAÑA.</div>
            <output id="percentage" class="percentage" data-context="percentage" for="range">{{
              (percent > 0 ? '+' : '') + percent + '%'
            }}</output>
            <label class="range-label" for="range">¿Cuánto cambiaron tus precios?</label>
            <input
              id="range"
              v-model.number="percent"
              class="range"
              type="range"
              data-input="price-adjust"
              min="-20"
              max="20"
              step="1"
              :aria-valuetext="rangeValueText"
              aria-describedby="rounding"
              @input="onAdjustInput"
            />
            <div class="range-scale" aria-hidden="true">
              <span>−20%</span>
              <span>0</span>
              <span>+20%</span>
            </div>
            <label class="scope-label" for="scope">Aplicar a</label>
            <select
              id="scope"
              v-model="scope"
              class="scope"
              data-input="price-scope"
              @change="onAdjustInput"
            >
              <option value="all">Toda la lista · 4 servicios</option>
              <option value="Gastronomía">Gastronomía · 2 servicios</option>
              <option value="Ambientación">Ambientación · 2 servicios</option>
            </select>
            <p class="rounding" id="rounding">↳ Redondeo al múltiplo de $ 500 más cercano.</p>
          </div>
          <div class="adjust-result">
            <div class="result-head">
              <b>Tu lista, al día.</b>
              <span class="tag">Demo</span>
            </div>
            <div id="price-rows">
              <div v-for="(service, i) in services" :key="service.name" class="price-row">
                <div class="service">
                  {{ service.name }}<small>{{ service.unit + ' · ' + service.category }}</small>
                </div>
                <div class="prices">
                  <del :hidden="!isChanged(i)"
                    ><span class="sr">Antes: </span
                    ><span class="old">{{ formatMoney(service.price ?? 0) }}</span></del
                  >
                  <strong :class="{ changed: isChanged(i) }"
                    ><span class="sr">Ahora: </span
                    ><span class="new">{{ formatMoney(newPrice(i)) }}</span></strong
                  >
                </div>
              </div>
            </div>
            <div
              id="update-chip"
              class="update-chip"
              :class="{ neutral: changedCount === 0 }"
              role="status"
            >
              {{ chipText }}
            </div>
            <button
              id="apply"
              class="apply"
              type="button"
              data-action="price-apply"
              :disabled="applyDisabled"
              @click="applyAdjustment"
            >
              {{ applyLabel }}
            </button>
          </div>
          <div class="immutable">
            <svg class="lock" viewBox="0 0 28 28" aria-hidden="true">
              <rect x="6" y="12" width="16" height="12" rx="4" />
              <path d="M9 12V8a5 5 0 0 1 10 0v4M14 16v4" />
            </svg>
            <div>
              <b>Presupuestos ya enviados no cambian.</b>
              <br />Lo que acordaste con tu cliente sigue igual.
            </div>
          </div>
        </div>
        <div class="proof-caption">
          <span>Probá también bajar el porcentaje.</span>
          <span>Simulación. No se guarda nada.</span>
        </div>
      </section>
      <section class="trust wrap" aria-labelledby="trust-title">
        <div class="trust-box">
          <div class="trust-copy reveal">
            <div class="eyebrow">La memoria de tu negocio</div>
            <h2 v-if="isCopyV2" id="trust-title">
              Una base que aprovechás<br />
              <span class="accent">en cada presupuesto.</span>
            </h2>
            <h2 v-else id="trust-title">
              Diez minutos hoy.<br />
              <span class="accent">Dos minutos,<br />para siempre.</span>
            </h2>
            <p v-if="isCopyV2">
              No cargás precios para una sola propuesta. Armás la base de tus presupuestos y
              consultas. Con tu marca y tus números.
            </p>
            <p v-else>
              No cargás precios para una sola propuesta. Armás la base de tus presupuestos,
              consultas, proyectos y documentos. Con tu marca y tus números.
            </p>
            <p>
              La lista se actualiza. La base no se vuelve a armar. Y tu negocio deja de vivir en tu
              cabeza. Y en tu cabeza sola.
            </p>
          </div>
          <div class="reveal">
            <div class="trust-catalog">
              <div class="mono">MIS SERVICIOS / CASA OLIVIA</div>
              <div class="row">
                <span
                  >Catering premium<small style="display: block; color: var(--muted)"
                    >Por persona</small
                  >
                </span>
                <b>$ 12.000</b>
              </div>
              <div class="row">
                <span>Mesa dulce</span>
                <b>$ 120.000</b>
              </div>
              <div class="row">
                <span>Vajilla</span>
                <b>$ 95.000</b>
              </div>
              <div class="destinations">
                <span>↗ Presupuestos</span>
                <span>↗ Consultas</span>
                <template v-if="!isCopyV2">
                  <span>↗ Proyectos</span>
                  <span>↗ Documentos</span>
                </template>
              </div>
              <p class="demo-note">Catálogo ilustrativo · Lo definís vos. Lo usa Prio.</p>
            </div>
            <p class="memory-note">{{ isCopyV2 ? 'Una base para consultas y presupuestos.' : 'Una base. Todo el negocio leyendo de ahí.' }}</p>
          </div>
        </div>
      </section>
      <section class="closing" aria-labelledby="closing-title">
        <div class="closing-ring" aria-hidden="true"></div>
        <span class="closing-flower" aria-hidden="true">✳</span>
        <div class="wrap reveal">
          <div class="eyebrow">Un poco de trabajo. Una vez.</div>
          <h2 v-if="isCopyV2" id="closing-title">
            Traé los precios como los tengas.<br />
            <span>Organizalos para el próximo presupuesto.</span>
          </h2>
          <h2 v-else id="closing-title">
            Tu lista puede estar lista<br />
            <span>antes del segundo mate.</span>
          </h2>
          <p v-if="isCopyV2">Empezá con la lista que ya usás. Sin plantillas ni formatos nuevos.</p>
          <p v-else>Traé los precios como los tengas.<br />Diez minutos hoy. Una cosa menos mañana.</p>
          <a class="cta" :href="SIGNUP_URL">Probá gratis <span aria-hidden="true">↗</span> </a>
          <div class="guarantee">Sin tarjeta · Cancelás cuando quieras</div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useHead } from '@unhead/vue';
import { useScrollReveal } from '@/composables/useScrollReveal';
import { useCopyVariant } from '@/composables/useCopyVariant';
import { SIGNUP_URL } from '@/constants';

const { isCopyV2 } = useCopyVariant();

useHead({
  title: 'Prio - Tu lista de precios, viva',
  meta: [
    {
      name: 'description',
      content:
        'Pegá tu lista desde Excel, notas o voz. La IA la organiza y categoriza, la ajustás por porcentaje y tus presupuestos salen en 2 minutos.',
    },
    { name: 'theme-color', content: '#f7f3fb' },
  ],
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Urbanist:wght@500;600;700;800;900&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap',
    },
  ],
});

interface CatalogService {
  name: string;
  price: number | null;
  unit: string;
  category: string;
  description: string;
}

const services: CatalogService[] = [
  {
    name: 'Catering premium',
    price: 12000,
    unit: 'Por persona',
    category: 'Gastronomía',
    description: 'Servicio de catering premium para tu evento, cotizado por persona.',
  },
  {
    name: 'Decoración',
    price: 280000,
    unit: 'Por servicio',
    category: 'Ambientación',
    description: 'Decoración temática para ambientar tu evento.',
  },
  {
    name: 'Mesa dulce',
    price: 120000,
    unit: 'Por servicio',
    category: 'Gastronomía',
    description: 'Mesa dulce para acompañar la celebración.',
  },
  {
    name: 'Vajilla',
    price: 95000,
    unit: 'Por servicio',
    category: 'Ambientación',
    description: 'Servicio de vajilla para tu evento.',
  },
];

const moneyFormat = new Intl.NumberFormat('es-AR');

function formatMoney(value: number): string {
  return '$ ' + moneyFormat.format(value);
}

const rootRef = ref<HTMLElement | null>(null);
const reducedMotion = ref(false);
let mediaQuery: MediaQueryList | null = null;
let sceneTimer = 0;

// Mess to clean scene (illustrative demo).
const sceneState = ref<'mess' | 'clean'>('clean');

function setScene(state: 'mess' | 'clean'): void {
  window.clearTimeout(sceneTimer);
  sceneState.value = state;
}

// Import review (local demo).
const confirmed = ref<string[]>([]);
const reviewStatus = ref('Tocá cada ✓ para confirmar el ejemplo.');

function toggleConfirm(name: string): void {
  confirmed.value = confirmed.value.includes(name)
    ? confirmed.value.filter((item) => item !== name)
    : [...confirmed.value, name];
  const count = confirmed.value.length;
  reviewStatus.value =
    count === 4
      ? '✓ Los 4 servicios confirmados en la demo.'
      : count + ' de 4 servicios confirmados en la demo.';
}

function importExample(): void {
  reviewStatus.value = 'Ejemplo organizado. Revisá los precios y confirmá cada servicio.';
  document
    .getElementById('revision')
    ?.scrollIntoView({ behavior: reducedMotion.value ? 'auto' : 'smooth', block: 'start' });
  (document.querySelector('#review button') as HTMLElement | null)?.focus({ preventScroll: true });
}

// Live list: search + highlight + tap-to-quote (local demo).
const categories = ['Gastronomía', 'Ambientación', 'Asesoramiento'];
const allServices = computed<CatalogService[]>(() => [
  ...services,
  {
    name: 'Consultoría',
    price: null,
    unit: 'Monto por presupuesto',
    category: 'Asesoramiento',
    description: '',
  },
]);
const search = ref('');
const added = ref<string[]>([]);
const variableOpen = ref<string | null>(null);
const variableAmount = ref('');
const quoteStatus = ref('Presupuesto de ejemplo · Agregá un servicio con +');

function normalizedQuery(): string {
  return search.value.trim().toLocaleLowerCase('es-AR');
}

function matchesFor(category: string): CatalogService[] {
  const query = normalizedQuery();
  return allServices.value.filter(
    (service) =>
      service.category === category && service.name.toLocaleLowerCase('es-AR').includes(query),
  );
}

const visibleCount = computed<number>(() =>
  categories.reduce((sum, category) => sum + matchesFor(category).length, 0),
);

function highlight(name: string): { pre: string; match: string; post: string } | null {
  const query = normalizedQuery();
  if (!query) return null;
  const index = name.toLocaleLowerCase('es-AR').indexOf(query);
  if (index === -1) return null;
  return {
    pre: name.slice(0, index),
    match: name.slice(index, index + query.length),
    post: name.slice(index + query.length),
  };
}

function priceLabel(service: CatalogService): string {
  if (service.price === null) return 'Variable';
  return formatMoney(service.price) + ' · ' + service.unit.toLocaleLowerCase('es-AR');
}

function addService(service: CatalogService, price: number | null): void {
  if (price === null) {
    if (variableOpen.value === service.name) return;
    variableOpen.value = service.name;
    variableAmount.value = '';
    return;
  }
  added.value = [...added.value, service.name];
  quoteStatus.value =
    '✓ ' +
    service.name +
    ' · ' +
    formatMoney(price) +
    ' agregado al presupuesto de ejemplo. ' +
    added.value.length +
    ' servicio' +
    (added.value.length === 1 ? '' : 's') +
    '.';
}

function submitVariable(service: CatalogService): void {
  const amount = Number(variableAmount.value);
  if (!Number.isFinite(amount) || amount <= 0) return;
  variableOpen.value = null;
  addService({ ...service, price: amount }, amount);
}

// Bulk adjust with smart rounding (local demo, nothing is saved).
const percent = ref(10);
const scope = ref('all');
const applied = ref(true);

const rangeValueText = computed<string>(
  () =>
    (percent.value > 0 ? 'Aumento del ' : percent.value < 0 ? 'Baja del ' : 'Sin cambio: ') +
    Math.abs(percent.value) +
    ' por ciento',
);

function round500(value: number): number {
  return Math.round(value / 500) * 500;
}

function newPrice(index: number): number {
  const service = services[index];
  const selected = scope.value === 'all' || scope.value === service.category;
  if (!selected || service.price === null) return service.price ?? 0;
  return round500(service.price * (1 + percent.value / 100));
}

function isChanged(index: number): boolean {
  return newPrice(index) !== (services[index].price ?? 0);
}

const changedCount = computed<number>(() => services.filter((_, i) => isChanged(i)).length);

const chipText = computed<string>(() => {
  if (changedCount.value === 0) return 'Sin cambios de precio';
  if (applied.value) return changedCount.value + ' actualizados en 1 click';
  return changedCount.value + ' por actualizar' + (percent.value < 0 ? ' · Baja de precios' : '');
});

const applyDisabled = computed<boolean>(() => applied.value || changedCount.value === 0);

const applyLabel = computed<string>(() => {
  if (changedCount.value === 0) return 'Sin cambios para aplicar';
  if (applied.value) return '✓ Ajuste aplicado en la demo';
  return 'Aplicar a ' + changedCount.value + ' servicios ↗';
});

function onAdjustInput(): void {
  applied.value = false;
}

function applyAdjustment(): void {
  applied.value = true;
}

// Stat count-ups (client-only, honors reduced motion).
let countObserver: IntersectionObserver | null = null;
let disposed = false;
const countRafIds = new Set<number>();

function animateCount(el: HTMLElement, end: number): void {
  const start = performance.now();
  const tick = (now: number): void => {
    if (disposed) return;
    const progress = Math.min(1, (now - start) / 850);
    el.textContent = String(Math.round(end * (1 - Math.pow(1 - progress, 3))));
    if (progress >= 1 || reducedMotion.value) {
      el.textContent = String(end);
      return;
    }
    countRafIds.add(requestAnimationFrame(tick));
  };
  countRafIds.add(requestAnimationFrame(tick));
}

function onMotionChange(): void {
  reducedMotion.value = mediaQuery?.matches ?? false;
  if (reducedMotion.value) {
    window.clearTimeout(sceneTimer);
    setScene('clean');
  }
}

onMounted(() => {
  mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  reducedMotion.value = mediaQuery.matches;
  mediaQuery.addEventListener('change', onMotionChange);
  if (!reducedMotion.value) {
    setScene('mess');
    sceneTimer = window.setTimeout(() => setScene('clean'), 1600);
  }
  if (!('IntersectionObserver' in window)) return;
  countObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        countObserver?.unobserve(entry.target);
        entry.target.querySelectorAll('[data-count]').forEach((node) => {
          if (node instanceof HTMLElement && !reducedMotion.value) {
            animateCount(node, Number(node.dataset.count));
          }
        });
      });
    },
    { threshold: 0.08 },
  );
  rootRef.value?.querySelectorAll('.reveal').forEach((el) => countObserver?.observe(el));
});

onUnmounted(() => {
  disposed = true;
  window.clearTimeout(sceneTimer);
  countObserver?.disconnect();
  mediaQuery?.removeEventListener('change', onMotionChange);
  countRafIds.forEach((id) => cancelAnimationFrame(id));
  countRafIds.clear();
});

useScrollReveal();
</script>

<style scoped>
/* Prototype delta: local danger token. */
.l3 {
  --red: #9b2845;
}
h1,
h2,
h3 {
  font-family: Urbanist, Arial, sans-serif;
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.04;
}
h1 {
  font-size: clamp(48px, 6vw, 80px);
}
h2 {
  font-size: clamp(38px, 4.6vw, 61px);
}
h3 {
  font-size: 34px;
}

a {
  color: inherit;
  text-decoration: none;
}
button,
input,
textarea,
select {
  font: inherit;
  color: inherit;
}
button,
a,
input,
select {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
button {
  cursor: pointer;
}
button,
a {
  min-height: 44px;
}
button {
  border: 0;
}
a:focus-visible,
button:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 3px solid var(--violet);
  outline-offset: 4px;
}
button:disabled {
  cursor: default;
}
input,
textarea,
select {
  max-width: 100%;
}
button {
  transition: transform 0.2s var(--ease);
}
button:active:not(:disabled),
.cta:active {
  transform: scale(0.97);
}
.wrap {
  width: min(1140px, calc(100% - 40px));
  margin-inline: auto;
}
.mono,
.eyebrow {
  font:
    10px/1.6 'IBM Plex Mono',
    monospace;
  letter-spacing: 0.07em;
}
.eyebrow {
  color: var(--violet);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 22px;
}
.eyebrow:before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--pink);
  flex-shrink: 0;
}
.cta {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  min-height: 56px;
  border: 1px solid #c9aee0;
  border-radius: 16px;
  background: var(--aurora);
  padding: 14px 23px;
  font-size: 13px;
  font-weight: 700;
  position: relative;
  isolation: isolate;
  overflow: hidden;
}
.cta:before {
  content: '';
  position: absolute;
  inset: -80% -60%;
  background: linear-gradient(100deg, transparent 42%, #ffffff85 50%, transparent 58%);
  transform: translateX(-75%) rotate(-10deg);
  z-index: -1;
}
.cta:hover:before {
  animation: sheen 0.8s var(--ease);
}
@keyframes sheen {
  to {
    transform: translateX(75%) rotate(-10deg);
  }
}
.guarantee {
  font-size: 10px;
  margin-top: 12px;
  color: var(--muted);
}
.hero {
  display: grid;
  gap: 24px;
  padding-top: 43px;
  padding-bottom: 62px;
}
.hero-copy > p {
  max-width: 430px;
  margin: 26px 0;
  font-size: 14px;
}

.underlined {
  position: relative;
  white-space: nowrap;
}
.underlined:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -7px;
  height: 10px;
  border-top: 2px solid var(--pink);
  border-radius: 50%;
  transform: rotate(-3deg);
}
.scene-wrap {
  min-width: 0;
  padding-top: 14px;
}
.scene {
  position: relative;
  height: 362px;
  isolation: isolate;
}
.scene:before {
  content: '';
  position: absolute;
  inset: 35px 0 18px;
  border-radius: 48% 55% 43% 50%;
  background: var(--aurora);
  transform: rotate(-9deg);
  z-index: -2;
  opacity: 0.64;
}
.orbit {
  position: absolute;
  inset: 13px 8px 8px;
  border: 1px solid #c9b5df;
  border-radius: 50%;
  transform: rotate(17deg);
  z-index: -1;
}
.spark {
  position: absolute;
  right: 3px;
  top: -11px;
  font-size: 68px;
  line-height: 1;
  color: var(--violet);
  transform: rotate(12deg);
}
.sheet {
  position: absolute;
  inset: 43px 19px 22px;
  border: 1px solid #e2d5e8;
  background: #fffcff;
  border-radius: 23px;
  padding: 23px;
  box-shadow: 0 20px 50px #31204712;
  transition:
    transform 0.85s var(--ease),
    opacity 0.6s var(--ease);
}
.sheet.clean {
  transform: rotate(-3deg);
}
.sheet.mess {
  background: #fff9e9;
  transform: rotate(4deg) translateY(12px);
  opacity: 0;
  pointer-events: none;
}
.scene[data-state='mess'] .clean {
  transform: rotate(-7deg) translateY(18px);
  opacity: 0;
}
.scene[data-state='mess'] .mess {
  transform: rotate(4deg);
  opacity: 1;
}
.sheet .sheet-title {
  font:
    800 24px/1.2 Urbanist,
    sans-serif;
  letter-spacing: -0.6px;
  margin: 13px 0 16px;
}
.sheet .row {
  font-size: 11px;
  padding: 11px 0;
}
.sheet .row b {
  white-space: nowrap;
}
.mess-text {
  font:
    15px/2.15 'IBM Plex Mono',
    monospace;
  margin-top: 16px;
  letter-spacing: -0.6px;
}
.mess-text span {
  background: #ffe2a3;
}
.mess .mono {
  color: #8a7046;
}
.seal {
  position: absolute;
  right: 0;
  bottom: 3px;
  background: var(--lime);
  border: 1px solid #c3dc96;
  border-radius: 13px;
  padding: 9px 14px;
  font-size: 10px;
  box-shadow: 0 8px 24px #31204712;
  transform: rotate(3deg);
  transition: opacity 0.3s;
}
.scene[data-state='mess'] .seal {
  opacity: 0;
}
.scene-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 18px;
}
.scene-controls button {
  padding: 8px 17px;
  border-radius: 99px;
  background: transparent;
  font-size: 11px;
}
.scene-controls button[aria-pressed='true'] {
  background: #eee5f7;
  border: 1px solid #d7c5e8;
}
.scene-caption {
  text-align: center;
  font-size: 10px;
  margin-top: 8px;
}
.ribbon {
  border-block: 1px solid #d7c3e2;
  background: var(--aurora);
  padding: 17px 20px;
  text-align: center;
  font:
    700 13px/1.5 Urbanist,
    sans-serif;
  letter-spacing: 0.03em;
}
.ribbon span {
  padding: 0 12px;
  color: var(--violet);
}
.section {
  padding: 70px 0;
}
.section-heading {
  display: grid;
  gap: 23px;
  margin-bottom: 35px;
}
.section-heading > p {
  max-width: 350px;
}
.stats {
  display: grid;
  gap: 0;
  border-block: 1px solid var(--line);
}
.stat {
  padding: 25px 0;
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 16px;
  align-items: center;
}
.stat + .stat {
  border-top: 1px solid var(--line);
}
.stat strong {
  font:
    800 54px/1 Urbanist,
    sans-serif;
  letter-spacing: -3px;
  white-space: nowrap;
}
.stat strong small {
  font-size: 25px;
  letter-spacing: -1px;
}
.stat h3 {
  font:
    700 13px/1.5 Inter,
    sans-serif;
  letter-spacing: 0;
  margin-bottom: 5px;
}
.stat p {
  font-size: 12px;
}
.context-end {
  margin-top: 23px;
  font-size: 13px;
}
.context-end b {
  color: var(--ink);
}
.steps-section {
  background: #efe8f5;
  border-block: 1px solid var(--line);
}
.steps-head {
  max-width: 660px;
  margin-bottom: 40px;
}
.steps-head p {
  margin-top: 22px;
  max-width: 440px;
}
.step {
  display: grid;
  gap: 28px;
  padding: 38px 0;
}
.step + .step {
  border-top: 1px solid #d9cce3;
}
.step-copy {
  position: relative;
}
.step-number {
  font:
    500 12px 'IBM Plex Mono',
    monospace;
  color: var(--violet);
  display: block;
  margin-bottom: 19px;
}
.step-copy p {
  margin-top: 21px;
  max-width: 350px;
}
.aside-note {
  font-size: 11px;
  color: var(--violet);
  border-left: 2px solid #bfa2dc;
  padding-left: 13px;
  margin-top: 23px;
  max-width: 320px;
}
.mock {
  background: #fffcff;
  border: 1px solid #e0d5e8;
  border-radius: 23px;
  box-shadow: 0 15px 40px #31204708;
  padding: 20px;
  min-width: 0;
}
.mock-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid var(--line);
  padding-bottom: 15px;
  margin-bottom: 17px;
}
.mock-top .mono {
  font-size: 9px;
}
.tag {
  display: inline-flex;
  align-items: center;
  border-radius: 7px;
  background: #efe7f8;
  color: #65458a;
  padding: 3px 7px;
  font-size: 9px;
  white-space: nowrap;
}
.sources {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 15px;
}
.sources span {
  border: 1px solid var(--line);
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 10px;
  background: #f9f5fc;
}
.paste-label {
  display: block;
  font-size: 11px;
  margin-bottom: 8px;
}
.paste {
  width: 100%;
  resize: vertical;
  min-height: 150px;
  background: repeating-linear-gradient(#faf7fc 0 29px, #ebe3f2 29px 30px);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 13px;
  font:
    12px/30px 'IBM Plex Mono',
    monospace;
}
.small-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 15px;
  border-radius: 12px;
  min-height: 46px;
  padding: 10px 14px;
  background: var(--aurora);
  font-size: 12px;
  font-weight: 600;
  margin-top: 12px;
}
.demo-note {
  font-size: 10px;
  color: var(--muted);
  margin-top: 12px;
}
.review-summary {
  font-size: 12px;
  color: var(--violet);
  margin-bottom: 12px;
}
.review-card {
  padding: 14px 0;
  border-top: 1px solid #eee5f2;
  display: grid;
  grid-template-columns: 1fr 44px;
  gap: 10px;
}
.review-card b {
  font-size: 12px;
  display: block;
}
.review-card .price {
  font-size: 11px;
}
.review-card p {
  font-size: 10px;
  line-height: 1.6;
  margin: 4px 0 7px;
}
.confirm {
  align-self: center;
  width: 44px;
  height: 44px;
  border: 1px solid #d8c9e4;
  border-radius: 13px;
  background: #f5eefb;
  color: var(--violet);
  font-size: 20px;
}
.confirm[aria-pressed='true'] {
  background: var(--lime);
  border-color: #c3db98;
  color: #34531e;
}
.search-label {
  font-size: 11px;
  display: block;
  margin-bottom: 7px;
}
.search {
  width: 100%;
  min-height: 46px;
  background: #f7f3fb;
  border: 1px solid var(--line);
  padding: 10px 13px;
  border-radius: 12px;
  font-size: 16px;
}
.category-title {
  font:
    500 9px 'IBM Plex Mono',
    monospace;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--violet);
  margin: 22px 0 5px;
}
.live-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee5f2;
}
.live-row > div {
  flex: 1;
  min-width: 0;
}
.live-row b {
  display: block;
  font-size: 12px;
}
.live-row small {
  font-size: 10px;
  color: var(--muted);
}
.add {
  min-width: 44px;
  height: 44px;
  background: #efe6f8;
  color: var(--violet);
  border: 1px solid #decdea;
  border-radius: 12px;
  font-size: 22px;
}
.add:disabled {
  background: #edf5e5;
  color: #315a23;
  font-size: 18px;
}
mark {
  background: var(--lime);
  color: var(--ink);
  border-radius: 3px;
}
.variable {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 7px;
  border: 1px solid #cbb7e2;
  border-radius: 6px;
  color: var(--violet);
  font-size: 10px;
}
.quote-status {
  background: #f5f0f9;
  padding: 11px;
  border-radius: 10px;
  margin-top: 15px;
  font-size: 10px;
  color: #665574;
  min-height: 44px;
}
.variable-entry {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.variable-entry input {
  width: 100%;
  min-width: 0;
  min-height: 44px;
  border: 1px solid var(--line);
  border-radius: 9px;
  padding: 8px;
  font-size: 16px;
}
.variable-entry button {
  background: var(--lime);
  border-radius: 9px;
  padding: 8px 12px;
  font-size: 11px;
}
.proof-heading {
  max-width: 690px;
}
.proof-heading p {
  max-width: 445px;
  margin: 23px 0 34px;
}
.proof {
  background: #fffcff;
  border: 1px solid #d9c5e6;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 24px 65px #3120470b;
}
.adjust-controls {
  position: relative;
  padding: 26px 23px;
  background: linear-gradient(135deg, #eee4ff, #fce9f1 80%, #fff2e6);
}
.adjust-controls:before {
  content: '✳';
  position: absolute;
  right: 15px;
  top: 30px;
  font-size: 90px;
  line-height: 1;
  color: #ffffffa0;
  pointer-events: none;
}
.adjust-controls .mono {
  position: relative;
  color: #6b4b81;
}
.percentage {
  display: block;
  position: relative;
  font:
    900 clamp(90px, 12vw, 142px) / 1.1 Urbanist,
    sans-serif;
  letter-spacing: -0.07em;
  margin: 13px 0 16px;
  color: var(--violet);
  background: linear-gradient(115deg, #6541bd 12%, #b35f9d 78%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: fit-content;
  padding-inline-end: 0.1em;
}
[data-negative='true'] .percentage {
  background: none;
  -webkit-text-fill-color: var(--red);
  color: var(--red);
}
.range-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
}
.range {
  display: block;
  width: 100%;
  height: 44px;
  margin: 5px 0 0;
  appearance: none;
  background: transparent;
  cursor: ew-resize;
  accent-color: var(--violet);
}
.range::-webkit-slider-runnable-track {
  height: 5px;
  border-radius: 9px;
  background: linear-gradient(to right, #c997ae, #bfa5dd);
}
.range::-moz-range-track {
  height: 5px;
  border-radius: 9px;
  background: #bfa5dd;
}
.range::-webkit-slider-thumb {
  appearance: none;
  width: 28px;
  height: 28px;
  background: #fffcff;
  border: 7px solid var(--violet);
  border-radius: 50%;
  margin-top: -11.5px;
  box-shadow: 0 3px 10px #6541bd30;
}
.range::-moz-range-thumb {
  width: 15px;
  height: 15px;
  background: #fffcff;
  border: 7px solid var(--violet);
  border-radius: 50%;
}
[data-negative='true'] .range::-webkit-slider-thumb {
  border-color: var(--red);
}
[data-negative='true'] .range::-moz-range-thumb {
  border-color: var(--red);
}
.range-scale {
  display: flex;
  justify-content: space-between;
  font:
    10px 'IBM Plex Mono',
    monospace;
  color: #766081;
  margin-bottom: 22px;
}
.scope-label {
  display: block;
  font-size: 11px;
  margin-bottom: 7px;
}
.scope {
  width: 100%;
  min-height: 46px;
  padding: 10px 12px;
  border: 1px solid #cbb5dc;
  background: #ffffff90;
  border-radius: 11px;
  font-size: 12px;
}
.rounding {
  margin-top: 12px;
  font-size: 10px;
  color: #6f587e;
}
.adjust-result {
  padding: 24px 20px;
}
.result-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.result-head b {
  font:
    800 24px Urbanist,
    sans-serif;
  letter-spacing: -0.6px;
}
.price-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  padding: 17px 0;
  border-bottom: 1px solid #e9dff0;
  align-items: center;
}
.price-row .service {
  font-size: 12px;
  font-weight: 600;
}
.price-row small {
  display: block;
  font-size: 9px;
  color: var(--muted);
  font-weight: 400;
}
.prices {
  text-align: right;
  white-space: nowrap;
  min-width: 92px;
}
.prices del {
  display: block;
  color: var(--muted);
  font-size: 10px;
}
.prices strong {
  display: block;
  font-size: 16px;
  color: var(--violet);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.4px;
}
[data-negative='true'] .prices strong.changed {
  color: var(--red);
}
.prices strong:not(.changed) {
  color: var(--ink);
}
.update-chip {
  display: inline-block;
  background: var(--lime);
  color: #34531e;
  padding: 7px 11px;
  border-radius: 9px;
  font-size: 10px;
  margin-top: 20px;
}
[data-negative='true'] .update-chip {
  background: #ffe4eb;
  color: var(--red);
}
.update-chip.neutral {
  background: #eee8f4;
  color: #62536f;
}
.apply {
  width: 100%;
  min-height: 46px;
  margin-top: 12px;
  background: var(--ink);
  color: #fff8ff;
  border-radius: 12px;
  font-size: 12px;
}
.apply:disabled {
  background: #eee7f4;
  color: #766483;
}
.immutable {
  border-top: 1px solid #e2d5e8;
  background: #fbf8fd;
  padding: 17px 23px;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.lock {
  width: 27px;
  height: 27px;
  flex-shrink: 0;
  stroke: var(--violet);
  fill: none;
  stroke-width: 1.5;
}
.proof-caption {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 15px;
  font-size: 10px;
  color: var(--muted);
}
.trust {
  padding: 12px 0 70px;
}
.trust-box {
  display: grid;
  gap: 35px;
  padding: 29px 24px;
  border: 1px solid #d9cbe5;
  border-radius: 28px;
  background: linear-gradient(120deg, #eee6f6, #f9eff5);
}
.trust-copy p {
  margin-top: 23px;
  max-width: 420px;
}
.trust-catalog {
  position: relative;
  background: #fffcff;
  border: 1px solid #e4d9eb;
  border-radius: 20px;
  padding: 23px;
  transform: rotate(-2deg);
  box-shadow: 0 15px 35px #3120470c;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e9dff0;
  padding: 14px 0;
  font-size: 11px;
}
.trust-catalog .mono {
  margin-bottom: 8px;
}
.destinations {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
  margin-top: 21px;
}
.destinations span {
  padding: 9px 10px;
  border: 1px solid #dccde9;
  border-radius: 9px;
  font-size: 10px;
  background: #f7f1fb;
}
.memory-note {
  margin-top: 20px;
  font-size: 11px;
  color: var(--violet);
}
.closing {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  text-align: center;
  padding: 75px 0 80px;
  background: linear-gradient(135deg, #e7dbfa, #f5e1ed 66%, #fae7d7);
  border-top: 1px solid #dfcce7;
}
.closing .eyebrow {
  justify-content: center;
}
.closing h2 {
  max-width: 780px;
  margin: auto;
}
.closing h2 span {
  color: var(--violet);
}
.closing p {
  margin: 23px auto 28px;
  max-width: 430px;
}
.closing-flower {
  position: absolute;
  right: -53px;
  bottom: -96px;
  font-size: 310px;
  line-height: 1;
  color: #ffffff75;
  z-index: -1;
  transform: rotate(15deg);
}
.closing-ring {
  position: absolute;
  left: -170px;
  top: 50px;
  width: 450px;
  height: 320px;
  border: 1px solid #cbb0dd80;
  border-radius: 50%;
  transform: rotate(-35deg);
  z-index: -1;
}

.sr {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
[hidden] {
  display: none !important;
}
.motion .reveal {
  opacity: 0;
  transform: translateY(22px);
  transition:
    opacity 0.65s var(--ease),
    transform 0.65s var(--ease);
}

@media (min-width: 760px) {
  .wrap {
    width: min(1140px, calc(100% - 80px));
  }
  .hero {
    grid-template-columns: 1.05fr 1fr;
    align-items: center;
    gap: 48px;
    padding-block: 75px 85px;
  }
  .hero-copy > p {
    font-size: 15px;
  }
  .scene {
    height: 420px;
  }
  .sheet {
    inset: 48px 24px 32px;
    padding: 28px;
  }
  .sheet .row {
    font-size: 12px;
    padding: 15px 0;
  }
  .sheet .sheet-title {
    font-size: 29px;
  }
  .mess-text {
    font-size: 17px;
    line-height: 2.4;
  }
  .seal {
    bottom: 12px;
    font-size: 11px;
  }
  .ribbon {
    font-size: 17px;
  }
  .ribbon span {
    padding-inline: 35px;
  }
  .section {
    padding: 95px 0;
  }
  .section-heading {
    grid-template-columns: 1.5fr 1fr;
    align-items: end;
    gap: 70px;
    margin-bottom: 45px;
  }
  .stats {
    grid-template-columns: repeat(3, 1fr);
    padding-block: 28px;
  }
  .stat {
    display: block;
    padding: 0 28px;
  }
  .stat:first-child {
    padding-left: 0;
  }
  .stat + .stat {
    border-top: 0;
    border-left: 1px solid var(--line);
  }
  .stat strong {
    font-size: 77px;
    display: block;
    margin-bottom: 20px;
  }
  .stat strong small {
    font-size: 34px;
  }
  .stat p {
    max-width: 235px;
  }
  .step {
    grid-template-columns: 1fr 1.1fr;
    gap: 80px;
    align-items: center;
    padding: 55px 0;
  }
  .step-copy h3 {
    font-size: 42px;
    max-width: 360px;
  }
  .mock {
    padding: 25px;
  }
  .step:nth-of-type(2) .mock {
    transform: rotate(1deg);
  }
  .proof {
    display: grid;
    grid-template-columns: 0.85fr 1.15fr;
  }
  .adjust-controls {
    padding: 35px;
  }
  .adjust-result {
    padding: 31px 35px;
  }
  .immutable {
    grid-column: 1/-1;
    justify-content: center;
  }
  .price-row {
    padding: 17px 0;
  }
  .price-row .service {
    font-size: 13px;
  }
  .prices strong {
    font-size: 19px;
  }
  .trust {
    padding: 5px 0 95px;
  }
  .trust-box {
    grid-template-columns: 1.2fr 1fr;
    gap: 70px;
    padding: 55px;
    align-items: center;
  }
  .trust-catalog {
    padding: 28px;
  }
  .closing {
    padding: 100px 0 105px;
  }
  .closing-flower {
    right: 20px;
    bottom: -105px;
  }
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *,
  *:before,
  *:after {
    animation: none !important;
    transition: none !important;
  }
  .motion .reveal {
    opacity: 1;
    transform: none;
  }
}
</style>
